import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e71657ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row w-100 align-items-center" }
const _hoisted_2 = { class: "flex-grow-1" }
const _hoisted_3 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_4 = {
  key: 1,
  class: "flex-shrink-0"
}
const _hoisted_5 = { class: "w-100 h-100" }
const _hoisted_6 = {
  key: 1,
  class: "d-flex property-filetree-element"
}
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = {
  class: "flex-grow-1 d-flex align-items-center justify-content-center border-primary border",
  style: {"min-height":"8rem"}
}
const _hoisted_9 = {
  key: 0,
  class: "flex-shrink-0 text-primary"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "cil cil-file" }, null, -1))
const _hoisted_11 = { class: "flex-grow-1 d-flex align-items-center" }
const _hoisted_12 = ["href", "download"]
const _hoisted_13 = { class: "flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_PropertyFileDisplay = _resolveComponent("PropertyFileDisplay")!
  const _component_translate = _resolveComponent("translate")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_PropertyFolderDisplay = _resolveComponent("PropertyFolderDisplay", true)!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: "w-100",
    onDragenter: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args)), ["stop","prevent"])),
    onDragleave: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args)), ["stop","prevent"]))
  }, [
    _createVNode(_component_Accordion, {
      activeIndex: null,
      class: "w-100 mb-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h4", {
                  class: _normalizeClass(["mb-0", { 'text-muted': _ctx.hasNoFileContents }])
                }, _toDisplayString(_ctx.folder.name), 3)
              ]),
              (_ctx.hasArchivedFiles && _ctx.isInternalUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_Button, {
                      class: "mr-3",
                      icon: "pi pi-clock",
                      label: _ctx.i18n.$gettext('Archiv'),
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showArchiveDialog = true), ["stop","prevent"]))
                    }, null, 8, ["label"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.interactive && _ctx.isInternalUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_FileUpload, {
                      mode: "basic",
                      class: "p-button-text p-button-sm flat",
                      name: "files",
                      url: _ctx.basePath + _ctx.propertyId,
                      multiple: false,
                      "max-file-size": 1000000000,
                      auto: true,
                      "choose-label": _ctx.i18n.$gettext('Hochladen'),
                      onBeforeSend: _ctx.interceptUploadAndChangeFilename,
                      onUpload: _ctx.onUploadDone,
                      onError: _ctx.onUploadFailed
                    }, null, 8, ["url", "choose-label", "onBeforeSend", "onUpload", "onError"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.files.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.files, (file) => {
                    return (_openBlock(), _createBlock(_component_PropertyFileDisplay, {
                      file: file,
                      interactive: _ctx.interactive,
                      "property-id": _ctx.propertyId,
                      onUpdateNeeded: _ctx.signalUpdateIsNeeded,
                      onArchive: ($event: any) => (_ctx.archiveFile(file))
                    }, null, 8, ["file", "interactive", "property-id", "onUpdateNeeded", "onArchive"]))
                  }), 256))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Keine Dateien hochgeladen")
                        ]),
                        _: 1
                      })
                    ])
                  ])),
              _createVNode(_Transition, {
                name: "scale",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_ctx.showDropZone)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "w-100 pl-2 mt-2 d-flex",
                        onDrop: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFileDrop && _ctx.handleFileDrop(...args)), ["stop","prevent"])),
                        onDragover: _withModifiers(() => {}, ["stop","prevent"])
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          (!_ctx.uploadInProgress)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _hoisted_10,
                                _createTextVNode(" "),
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Datei hier fallen lassen, um sie hochzuladen")
                                  ]),
                                  _: 1
                                })
                              ]))
                            : (_openBlock(), _createBlock(_component_ProgressBar, {
                                key: 1,
                                class: "w-50",
                                mode: "indeterminate"
                              }))
                        ])
                      ], 32))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.children.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.children, (child) => {
                    return (_openBlock(), _createBlock(_component_PropertyFolderDisplay, {
                      folder: child,
                      interactive: _ctx.interactive,
                      "property-id": _ctx.propertyId,
                      onUpdateNeeded: _ctx.signalUpdateIsNeeded,
                      class: "d-flex property-filetree-element filetree-directory"
                    }, null, 8, ["folder", "interactive", "property-id", "onUpdateNeeded"]))
                  }), 256))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      header: _ctx.i18n.$gettext('Datei anlegen'),
      visible: _ctx.showNewFileDialog,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showNewFileDialog) = $event)),
      onHide: _ctx.resetModal,
      onSubmit: _ctx.createNewFile,
      modal: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.i18n.$gettext('Abbrechen'),
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _ctx.resetModal
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.i18n.$gettext('Speichern'),
          icon: "pi pi-check",
          autofocus: "",
          disabled: !_ctx.newFileName,
          type: "submit"
        }, null, 8, ["label", "disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_AnimatedInput, {
          modelValue: _ctx.newFileName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newFileName) = $event)),
          "auto-resize": "",
          label: _ctx.i18n.$gettext('Name der Datei'),
          class: "mb-4",
          required: ""
        }, null, 8, ["modelValue", "label"])
      ]),
      _: 1
    }, 8, ["header", "visible", "onHide", "onSubmit"]),
    _createVNode(_component_Dialog, {
      header: _ctx.i18n.$gettext('Vorherige Versionen'),
      visible: _ctx.showArchiveDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showArchiveDialog) = $event)),
      onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showArchiveDialog = false)),
      modal: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.archivedFiles, (f) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex",
            key: f.name
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("a", {
                href: _ctx.assembleDownloadUrlOfFile(f),
                download: f.name
              }, [
                _createTextVNode(_toDisplayString(f.name) + ", " + _toDisplayString(_ctx.fileSizeFormatted(f)) + ", ", 1),
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("vom")
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.formatIsoDate(f.created)), 1)
              ], 8, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.isInternalUser)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-trash",
                    size: "small",
                    class: "flat",
                    disabled: _ctx.interactive,
                    label: _ctx.i18n.$gettext('Löschen'),
                    text: "",
                    onClick: ($event: any) => (_ctx.reallyDeleteFile(f))
                  }, null, 8, ["disabled", "label", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 32))
}